var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckmarkNonfilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Final Status",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 174966"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "checkmark--filled (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 2",
    d: "M12013 19815.5a6 6 0 1 1 6-6 6.01 6.01 0 0 1-6 6zm-2.686-6.578-.677.676 2.4 2.4 4.321-4.322-.681-.676-3.641 3.641-1.726-1.721z",
    transform: "translate(-12006.998 -19803.5)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.143 15.539 9 13.4l.682-.682 1.461 1.461L14.319 11l.684.679z",
    transform: "translate(-5.998 -7.143)",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "inner-path",
    d: "M11.143 15.539 9 13.4l.682-.682 1.461 1.461L14.319 11l.684.679z",
    transform: "translate(-6.001 -7.143)",
    style: {
      fill: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkNonfilled);
export default __webpack_public_path__ + "static/media/checkmark-nonfilled.3ebf4785634c32cb72d0f0ae6d817531.svg";
export { ForwardRef as ReactComponent };